import * as React from "react";
import { ModuleMapProps } from "./typings";
import { Maps } from "./Maps";
import { DynamicMaps } from "./views/DynamicMaps";
import { withStores } from "stores";
import { EGMaps } from "./EGMaps";
import { observer } from "mobx-react";
// Experiment
import { Experiment as Experiments } from "components/utility/experiment";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

export const MapsViews = withStores(
  "analytics",
  "hotels",
  "staticMap",
  "context",
  "flexModuleModelStore",
  "flightsStore"
)(
  observer((props: ModuleMapProps) => {
    const { EG_Maps_lodging_landing_page_adoption } = Experiments;
    if (props.flexTemplateNode.options.flexComponentView === "dynamic") {
      return <DynamicMaps {...props} />;
    }

    return (
      <Experiment name={EG_Maps_lodging_landing_page_adoption}>
        <ExperimentControl>
          <Maps {...props} />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <EGMaps {...props} />
        </ExperimentVariant>
      </Experiment>
    );
  })
);

export default MapsViews;
